import { OperationType } from "./operationTypeEnum";
import { Pays } from "./pays";
import { ProfilConfigurationSaisieDonneesAnalyse } from "./profilConfigurationSaisieDonneesAnalyse";
import { Projet } from "./projet";
import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";
import { Region } from "./region";
import { SiteFeatures } from "./siteFeatures";

export class SiteBasicDTO {
  public siteId: number;
  public nom: string;
  public isActif: boolean;
  public orgId: number;
}

export class Site {
  orgId: number;
  siteId: number;
  nom: string;
  isActif: boolean;
  regionId: number;
  paysId: number;
  region: Region;
  groupByNomRegion: string;
  pays: Pays;
  nbUtilisateurs: number;
  nbZones: number;
  profilId: number;
  profil: ProfilConfigurationSaisieDonneesAnalyse;
  projets: Projet[];
  //siteStat: SiteStat;
  epsg: string;
  epsgCoordinates: string;
  coordX: number;
  coordY: number;
  configurationTreeview: string;
  configurationKPI: string;
  currency: string;
  timezone?: string;
  operationType: OperationType;
  features?: SiteFeatures;
  numberBlasts?: number;


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('isActif', 'GLOBAL.ACTIF', '',
      new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    tab.push(new ProprieteAffichee('region', 'GLOBAL.REGION', 'nom'));
    tab.push(new ProprieteAffichee('pays', 'GLOBAL.PAYS', 'nom'));
    tab.push(new ProprieteAffichee('nbUtilisateurs', 'GLOBAL.UTILISATEURS', '', new CustomAffichage(TypePropriete.Number)));
    tab.push(new ProprieteAffichee('nbZones', 'GLOBAL.ZONES', '', new CustomAffichage(TypePropriete.Number)));

    // tab.push(new ProprieteAffichee('siteStat', 'GLOBAL.NOMBRE_TIR', 'blastCount', new CustomAffichage(TypePropriete.Number)));
    // tab.push(new ProprieteAffichee('siteStat', 'GLOBAL.NOMBRE_TIR_30JOURS', 'blastCountLast30Days', new CustomAffichage(TypePropriete.Number)));

    //tab.push(new ProprieteAffichee('epsg', 'EPSG.EPSG'));
    //tab.push(new ProprieteAffichee('coordX', 'EPSG.X'));
    //tab.push(new ProprieteAffichee('coordY', 'EPSG.Y'));
    return tab;
  }
}

export class SiteStat {
  siteId: number;
  blastCount: number;
  blastCountLast30Days: number;
}
